const Footer = () => (
  <footer>For more information about PDB file downloads please see the <a href="https://www.wwpdb.org/ftp/pdb-ftp-sites">wwPDB website</a></footer>
);

export default Footer;
